export default __webpack_public_path__ + "static/media/6-min.6ab17442.jpg";